import styled from '@emotion/styled';
import { gettext } from '@eventbrite/i18n';
import { Button } from '@eventbrite/marmalade';
import React from 'react';

export enum ActionBarTestIds {
    Create = 'ActionBarCreate',
    Exit = 'ActionBarExit',
}

export const ActionBar = () => {
    return (
        <Container>
            <div>
                <Button
                    data-heap-id="create-event-logged-out-auto-create-event"
                    data-testid={ActionBarTestIds.Create}
                    variant="primary"
                    type="submit"
                >
                    {gettext('Create event')}
                </Button>
            </div>
        </Container>
    );
};

const Container = styled.div`
    align-items: center;
    background: white;
    border-top: 1px solid #eeedf2;
    bottom: 0;
    display: flex;
    flex-direction: row;
    gap: 12px;
    justify-content: flex-end;
    padding: 12px;
    position: fixed;
    right: 0;
    width: 100%;
    z-index: 20;

    div {
        flex: 1;
    }

    button {
        padding: 0 4px;
        width: 100%;
    }

    @media all and (min-width: 480px) {
        div {
            flex: 0 0 auto;
        }

        button {
            padding: 0 24px;
        }
    }

    @media all and (min-width: 960px) {
        padding: 20px 32px;
    }
`;
